<template>
  <div class="main">

      <div class="tutorial-content-wrapper">
        <h3>Let's create a Daily Startup checklist <TextToSpeechSimple :inputText="textOneSpeech"></TextToSpeechSimple></h3>
        <!-- <p>{{interactionNeeded ? 'This is an interactive page' : 'This is a static page'}}</p>
        <button class="button is-primary" @click="sendData">{{hasInteracted ? 'Good job' : 'Click to interact'}}</button> -->

        <h4>Click the "Add Helper Items" button below to add some items to your daily startup checklist.</h4>

        <div class="card">
          <!-- <h3 class="heading">SELECTED STARTUP ITEMS</h3> -->
            <!-- <div v-for="item in sorted(vesselItems)"> -->
            <div v-for="item in selectedItems" :key="item.id">
              <div class="notification">
                <div class="item-title">{{item.title}}</div>
                <div class="item-details">
                  <div v-for="line in item.details.split('\n')" :key="line.id">{{line}}<br></div>
                </div>
                <!-- <div v-if="isVesselOwner" class="buttons">
                  <span class="button is-success" @click="launchEditItem(item.id,item.title,item.details)">Edit</span>
                  <span class="button is-danger" @click="removeItem(item.id)">Remove</span>
                </div> -->
              </div>  
            </div>
            <!-- <span class="simple-link right" @click="enableSortModal">Change order</span> -->
        </div>


        <button @click="launchAddHelperItems" class="button is-primary">{{selectedItems.length > 0 ? 'Edit Helper Items' : 'Add helper Items'}}</button>

        <p></p>
        <img v-if="showNextStep && selectedItems.length > 0" class="smiley"  src="../assets/popeye.jpg" alt="Offshore SMS">
        <h4 v-if="showNextStep && selectedItems.length > 0">Nice work. Click on Next below.</h4>

        <div class="bottom-spacer"></div>

      </div>


      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':isActiveAddHelperItems}">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Add some startup checks:</p>
            <button class="delete" aria-label="close" @click.prevent="close"></button>
          </header>
          <section class="modal-card-body"> 

            <div class="checkbox-wrapper">
              <div class="field" v-for="item in helperItems" :key="item.id">
                <input class="is-checkradio" type="checkbox" :id="item.id" :value="item" v-model="selectedItems">
                <label :for="item.id">{{item.title}}</label>
              </div>
            </div>

          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary" @click="saveHelperItems">{{selectedItems.length > 0 ? 'Update Items' : 'Add helper Items'}}</button>
            <button class="button cancel" @click.prevent="close">Cancel</button>
          </footer>
        </div>
      </div>




  </div>
</template>


<script>

import { db } from '../main.js';
import NProgress from 'nprogress';
import * as bulmaToast from "bulma-toast";
import TextToSpeechSimple from '../components/TextToSpeechSimple.vue';

export default {

  components: {
      TextToSpeechSimple,
  },

  props: [
      'interactionNeeded',
  ],

  computed: {

  },

  mounted() {
    this.loadHelperItems();
    bulmaToast.setDoc(window.document);
  },

  data() {
    return {
      hasInteracted: false,
      isActiveAddHelperItems: false,
      helperItems: [],
      selectedItems: [],
      showNextStep: false,
      toastShown: false,
      textOneSpeech: 'Let\'s create, a Daily Start up checklist. Click the "Add Helper Items" button below to add some items to your daily start up checklist.',
    }
  },

  methods: {

    loadHelperItems: function() {
      var self = this;
      db.collection("helperStartupItems").orderBy("key","asc").onSnapshot(function(querySnapshot) {
        self.helperItems = [];
        querySnapshot.forEach(function(doc) {
          self.helperItems.push({
            id: doc.id,
            title: doc.data().title,
            details: doc.data().details
          });
        });
      });
    },

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

    launchAddHelperItems: function() {
      this.isActiveAddHelperItems = true;
      this.showNextStep = true;
      this.sendData();
    },

    close: function() {
      this.isActiveAddHelperItems = false;
    },

    showToast() {      
      if (!this.toastShown) {
        bulmaToast.toast({ 
          message: "Proceed to next page",
          type: "is-success",
          // dismissible: true,
          animate: { in: "fadeIn", out: "fadeOut" },
          position: "bottom-right",
          duration: 2000
        });
        this.toastShown = true;
      }
    },

    sendData: function() {
      let self = this;
      self.hasInteracted = true;
      let result = {
        hasInteracted: self.hasInteracted,
        // returnValue: self.returnValue
      }
      this.$emit('sendData', result)
    },

    saveHelperItems: function() {
      NProgress.start();
      // var self = this;
      if (this.selectedItems.length) {
        console.log('something');
        this.isActiveAddHelperItems = false;
        NProgress.done();
        // this.showToast();
      } else {
        console.log("nothing selected");
        this.isActiveAddHelperItems = false;
        NProgress.done();
      }
    },
    
  }
}
</script>



<style lang="scss" scoped>

  button {
    margin-top: 1rem;
  }

  .card {
    margin-top: 2rem;
    .notification {
      margin-bottom: 1rem;
      text-align: left;
      .item-title {
        font-weight: bold;
        text-transform: uppercase;
        padding-bottom: 5px;
        border-bottom: 1px solid #ddd;
      }
      .item-details {
        margin: 10px 0;
      }
    }
  }


  textarea {
    // min-height: 100px !important;
    box-shadow: none;
    padding: 0.6rem 1rem;
  }

  .checkbox-wrapper {
    margin-bottom: 1rem;
    width: 100%;
    border-bottom: 1px dashed #eee;
    padding-bottom: 10px;
    .checkbox-content {
      float: left;
      width: calc(100% - 90px);
    }
  }



</style>